export function formatDateString(dateStr) {
  // Create a new Date object
  const date = new Date(dateStr);

  // Define options for date formatting
  const dateOptions = {
    year: "numeric",
    month: "long",
    day: "2-digit",
  };

  // Define options for time formatting
  const timeOptions = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // Use 12-hour clock
  };

  // Get the formatted date and time parts
  const formattedDate = date.toLocaleDateString("en-US", dateOptions);
  const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

  // Combine date and time parts
  return `${formattedDate} at ${formattedTime}`;
}
export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const formatNumberToTwoDecimals = (number) => {
  // Use parseFloat to ensure we're working with a number
  const parsedNumber = parseFloat(number);

  // Check if parsedNumber is NaN or not a number, return 0.00 in such cases
  if (isNaN(parsedNumber)) {
    return "0.00";
  }

  // Use toFixed to format number to two decimal places
  const formattedNumber = parsedNumber.toFixed(2);

  return formattedNumber;
};
